"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AnimationStorage = (function () {
    function AnimationStorage() {
        this.coinIn = [];
        this.coinOut1 = [];
        this.coinOut2 = [];
        this.shine1 = [];
        this.shine2 = [];
        this.coinInCounter = 0;
        this.coinOutCounter = 0;
        this.shine1Counter = 0;
        this.shine2Counter = 0;
    }
    AnimationStorage.prototype.load = function () {
        this.loadCoinsOut();
        this.loadDefaultCoins();
        this.loadCoinIn();
        this.loadShine1();
        this.loadShine2();
    };
    AnimationStorage.prototype.loadCoinIn = function () {
        var _this = this;
        if (this.coinIn.length === 26) {
            return;
        }
        else {
            var tempImg_1 = new Image();
            tempImg_1.src = 'img/coin/anim/in/coin_in_0' + String(this.coinInCounter).padStart(2, '0') +
                '.png';
            tempImg_1.onload = function () {
                _this.coinIn.push(tempImg_1);
                _this.coinInCounter++;
                _this.loadCoinIn();
            };
        }
    };
    AnimationStorage.prototype.loadCoinsOut = function () {
        var _this = this;
        if (this.coinOut1.length === 10) {
            return;
        }
        else {
            var tempImg1_1 = new Image();
            var tempImg2_1 = new Image();
            tempImg1_1.src = 'img/coin/anim/out_1/out_1_0' + String(this.coinOutCounter).padStart(2, '0') +
                '.png';
            tempImg2_1.src = 'img/coin/anim/out_2/out_2_0' + String(this.coinOutCounter).padStart(2, '0') +
                '.png';
            tempImg1_1.onload = function () {
                _this.coinOut1.push(tempImg1_1);
                _this.coinOut2.push(tempImg2_1);
                _this.coinOutCounter++;
                _this.loadCoinsOut();
            };
        }
    };
    AnimationStorage.prototype.loadShine1 = function () {
        var _this = this;
        if (this.shine1.length === 31) {
            return;
        }
        else {
            var tempImg_2 = new Image();
            tempImg_2.src = 'img/coin/anim/shine_1/shine_1_0' + String(this.shine1Counter).padStart(2, '0') +
                '.png';
            tempImg_2.onload = function () {
                _this.shine1.push(tempImg_2);
                _this.shine1Counter++;
                _this.loadShine1();
            };
        }
    };
    AnimationStorage.prototype.loadShine2 = function () {
        var _this = this;
        var coinsLoaded = new CustomEvent('coinsLoaded', { detail: {
                coinIn: this.coinIn,
                coinOut1: this.coinOut1,
                coinOut2: this.coinOut2,
                coin1: this.coin1default,
                coin2: this.coin2default,
                shine1: this.shine1,
                shine2: this.shine2
            }
        });
        if (this.shine2.length === 31) {
            window.dispatchEvent(coinsLoaded);
            return;
        }
        else {
            var tempImg_3 = new Image();
            tempImg_3.src = 'img/coin/anim/shine_2/shine_2_0' + String(this.shine2Counter).padStart(2, '0') +
                '.png';
            tempImg_3.onload = function () {
                _this.shine2.push(tempImg_3);
                _this.shine2Counter++;
                _this.loadShine2();
            };
        }
    };
    AnimationStorage.prototype.loadDefaultCoins = function () {
        this.coin1default = new Image();
        this.coin1default.src = 'img/coin/anim/shine_1/shine_1_030.png';
        this.coin2default = new Image();
        this.coin2default.src = 'img/coin/anim/shine_2/shine_2_030.png';
        this.dice1default = new Image();
        this.dice1default.src = 'img/coin/coin_dice_1.png';
        this.dice2default = new Image();
        this.dice2default.src = 'img/coin/coin_dice_2.png';
    };
    return AnimationStorage;
}());
exports.default = AnimationStorage;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/coin-animation/animation-storage.ts
// module id = 2406
// module chunks = 5